export default __webpack_public_path__ + "static/tax-deferral-icon-0b32bc9acc1008dcefcb9bf32153e672.svg";